import React, {useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {getStoreConfig} from "../../../../services/Store/reducer";
import {getSession} from "../../../../services/Session/reducer";
import {RootState} from "../../../../../reducers";
import {ReactComponent as MarkerSVG} from "../../../../../images/icons/marker.svg";
import {ReactComponent as ArrowRightSVG} from "../../../../../images/icons/arrow-right.svg";
import {ReactComponent as EditSVG} from "../../../../../images/icons/edit.svg";
import ChangeLocationModal from "../../../../components/Modal/ChangeLocationModal";
import {FormatAddressString} from "go-core/components/Formatters/FormatAddress";
import RoundedIcon from "../../../../components/Common/RoundedIcon";
import AppConfig from "../../../../services/AppConfig";

type Props = ReturnType<typeof mapStateToProps> & DispatchProp;
const MenuLocationFilterComponent = (props: Props) => {
    const [addressModal, setAddressModal] = useState(false);
    const {t} = useTranslation();

    if (!props.config) return null;

    const getClassNameForRoundedIcon = () => {
        if (!props.session.full_address) return "";
        if (props.session.full_address) {
            if (props.session.in_delivery_area) return "text-success";
            if (!props.session.in_delivery_area) return "text-danger";
        }
    }

    const isAddressSet = ( ) => {
      return props.session.full_address;
    }

    const getDeliveryInformationText = () => {
        if(isAddressSet() && props.session.in_delivery_area) return t("modules.menu.field.delivery_available.title");
        if(isAddressSet() && !props.session.in_delivery_area) return t("modules.menu.field.delivery_unavailable.title");
        return t("modules.menu.action.check_delivery.title")
    }

    const getClassNameForSmallElement = () => {
        if(isAddressSet() && !props.session.in_delivery_area) return "text-danger";
        return "";
    }

    return (
        <div className={"container-fluid"}>
            <button className={"btn btn-default w-100 menu-location-filter-btn"} onClick={() => setAddressModal(true)}>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex">
                        <RoundedIcon icon={<MarkerSVG />} className={`me-3 ${getClassNameForRoundedIcon()}`} size="medium"/>
                        <div className="d-flex flex-column align-items-start">
                            <p className={`mb-0 text fw-medium ${getClassNameForSmallElement()}`}>{getDeliveryInformationText()}</p>
                            <small className={`mb-0 ${AppConfig.isDarkMode() ? "" : "text-primary"}`}>{isAddressSet() ? FormatAddressString(props.session.address): t("modules.menu.action.set_delivery_address.title")}</small>
                        </div>
                    </div>
                    {isAddressSet() ? <EditSVG className={`${AppConfig.isDarkMode() ? 'edit-icon' : "text-primary"}`} /> : <ArrowRightSVG />}
                </div>
            </button>

            <ChangeLocationModal showModal={addressModal}
                                 onHide={() => setAddressModal(false)}/>
        </div>
    )
}


const mapStateToProps = (state: RootState) => ({
    config: getStoreConfig(state.config),
    session: getSession(state.session)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuLocationFilterComponent));